import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { isPendingAction, isRejectedAction, isFullfieldAction } from './slice.helper';
import Api from '../../services/arrivage-fb.service';



export const listArrivageFB = createAsyncThunk(
    "ArrivageFB/adm-list",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.viewAll(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const viewArrivageFB = createAsyncThunk(
    "ArrivageFB/adm-view",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.view(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const createArrivageFB = createAsyncThunk(
    "ArrivageFB/adm-create",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.create(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateArrivageFB = createAsyncThunk(
    "ArrivageFB/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.update(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)

export const updateCmdMultiStatus = createAsyncThunk(
    "ArrivageFB/adm-update",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.updateMultiStatus(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)


export const deleteArrivageFB = createAsyncThunk(
    "ArrivageFB/adm-delete",
    async (data, { rejectWithValue }) => {
        try {
            const res = await Api.remove(data);
            return res.data;
        } catch (error) {
            const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString();
            return rejectWithValue(message)
        }
    }
)






const initialState = {
    loading: false,
    error: '',
    sel_ArrivageFB: null
}

const ArrivageFBSlice = createSlice({
    name: "ArrivageFB",
    initialState: initialState,
    reducers: {
        clear: (state) => {
            Object.assign(state, initialState)
        },
        set_error: (state , action) => {
            state.error = action.payload
        },

    },
    extraReducers: builder => {
        builder
            .addMatcher(isFullfieldAction, (state, action) => {
                state[action.meta.requestId] = 'fulfilled'
                state.loading = false;
                state.error = '';
            })
            .addMatcher(isPendingAction, (state, action) => {
                state[action.meta.requestId] = 'pending'
                state.loading = true;
                state.error = '';
            })
            .addMatcher(isRejectedAction, (state, action) => {
                state[action.meta.requestId] = 'rejected'
                state.loading = false;
                state.error = action.payload;
            })



    }
})

const { reducer } = ArrivageFBSlice;
export const { clear, set_error } = ArrivageFBSlice.actions;
export default reducer;